import {
	getUseCaseIcon,
	type ConversationAction,
	type PromptCard,
} from '@atlassian/rovo-conversation-actions';
import { HandleActionType } from '@atlassian/rovo-conversation-actions/types';

const MAX_EMPTY_PAGE_ACTIONS = 3;

export const getEmptyPageCreationActions = (promptCards: PromptCard[]): ConversationAction[] => {
	return promptCards.slice(0, MAX_EMPTY_PAGE_ACTIONS).map((card) => ({
		handleType: HandleActionType.Chat,
		id: card.id,
		title: card.title,
		staticPrompt: card.prompt,
		icon: getUseCaseIcon(card.useCase),
	}));
};
